'use client';

import { useContext } from 'react';
import { PageContext } from '@/features/app-providers/page-provider';

export const useIsVenueRouterPage = () => {
    return useContext(PageContext).pageName === 'venue-router';
};
